class ServiceContent extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.showMore = this.querySelector(".show-more");
    this.showLess = this.querySelector(".show-less");
    this.viewProduct = this.querySelector(".view-product")
    this.description = this.querySelector(".service-description");
    this.servicesPackage = this.closest("services-package");

    this.showMore.addEventListener("click", this.handleShowMore.bind(this));
    this.showLess.addEventListener("click", this.handleShowLess.bind(this));
    this.viewProduct.addEventListener("click", this.handleShowLess.bind(this));

    this.checkbox = this.querySelector(
      '.checkbox-wrapper input[type="checkbox"]'
    );
    this.addEventListener("click", this.handleActivation.bind(this));
  }

  handleActivation(event) {
    event.preventDefault();
    let target = event.target;
    if (
      !target.classList.contains("show-icon") &&
      !target.classList.contains("icon") &&
      !target.classList.contains("service-checkbox")
    ) {
      if (this.checkbox.checked) {
        this.checkbox.checked = false;
      } else {
        this.checkbox.checked = true;
      }
      this.servicesPackage.updatePackagePrice(this.checkbox);
    }
  }

  handleShowMore(event) {
    event.preventDefault();
    if (
      (this.description != null) &
      (this.showMore != null) &
      (this.showLess != null)
    ) {
      this.description.classList.remove("closed");
      this.showMore.classList.add("inactive");
      this.showLess.classList.remove("inactive");
    }

    this.scrollTo();
  }

  handleShowLess(event) {
    event.preventDefault();
    if (
      (this.description != null) &
      (this.showMore != null) &
      (this.showLess != null)
    ) {
      this.description.classList.add("closed");
      this.showMore.classList.remove("inactive");
      this.showLess.classList.add("inactive");
    }

    this.scrollTo();
  }

  scrollTo() {
    window.scrollTo({
      top: this.getBoundingClientRect().top + window.scrollY - 90,
      behavior: theme.config.motionReduced ? "auto" : "smooth",
    });
  }
}

customElements.define("service-content", ServiceContent);

class ServicesPackage extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.totalPrice = 0;
    this.packagePrice = document.getElementById("package_price");
    this.checkboxes = this.querySelectorAll('.service input[type="checkbox"]');

    // Format the price above to USD using the locale, style, and currency.
    this.USDollar = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    // this.checkboxes.forEach((checkbox) =>
    //    checkbox.addEventListener("change", this.handleCheck.bind(this))
    // );
    this.checkRequired();

    //Package Request CTA
    this.packageRequestButton = document.getElementById(
      "button_package_request"
    );
    this.packageRequestButton.addEventListener(
      "click",
      this.handlePackageRequest.bind(this)
    );
  }

  handleCheck(event) {
    let checkbox = event.currentTarget;
    this.updatePackagePrice(checkbox);
  }

  checkRequired() {
    let required_checkboxes = this.querySelectorAll(
      '.service input[type="checkbox"]:checked'
    );
    required_checkboxes.forEach((checkbox) => {
      this.updatePackagePrice(checkbox);
    });
  }

  updatePackagePrice(checkbox) {
    if (checkbox) {
      var price = parseInt(checkbox.dataset.price) / 100;
      if (checkbox.checked) {
        this.totalPrice = this.totalPrice + price;
      } else {
        this.totalPrice = this.totalPrice - price;
      }

      this.packagePrice.innerHTML = this.USDollar.format(this.totalPrice);
    }
  }

  handlePackageRequest() {
    let formData = {
      items: [],
    };

    let on_checkboxes = this.querySelectorAll(
      '.service input[type="checkbox"]:checked'
    );

    if (on_checkboxes.length < 1) {
      alert("Please select at least one service.");
      return;
    }

    on_checkboxes.forEach((checkbox) => {
      var variant_id = checkbox.dataset.variantId;
      let item = {
        id: variant_id,
        quantity: 1,
      };

      formData.items.push(item);
    });

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        //return response.json();
        window.location.href = "/cart";
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}
customElements.define("services-package", ServicesPackage);
